import { createBrowserHistory } from "history";

const history=createBrowserHistory({basename:'/suppweb'});
export default history;



